const conversionFactors = {
  'Hertz': 1,
  'Kilohertz': 1e3,
  'Megahertz': 1e6,
  'Gigahertz': 1e9,
  'Terahertz': 1e12,
  'Cycles per second': 1,
  'Radians per second': 1 / (2 * Math.PI),
  'Revolutions per minute (RPM)': 1 / 60,
  'Beats per minute (BPM)': 1 / 60,
};

const c = 299792458; // Speed of light in m/s

export const convertFrequency = (value, fromUnit, toUnit) => {
  if (fromUnit === 'Wavelength (meters)') {
    value = c / value;
  } else if (fromUnit === 'Wavenumber (cm⁻¹)') {
    value = value * 100 * c;
  } else {
    value = value * conversionFactors[fromUnit];
  }

  if (toUnit === 'Wavelength (meters)') {
    return c / value;
  } else if (toUnit === 'Wavenumber (cm⁻¹)') {
    return value / (100 * c);
  } else {
    return value / conversionFactors[toUnit];
  }
};
